import { render, staticRenderFns } from "./BeautyCategoryForm.vue?vue&type=template&id=671de086&scoped=true"
import script from "./BeautyCategoryForm.vue?vue&type=script&lang=js"
export * from "./BeautyCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./BeautyCategoryForm.vue?vue&type=style&index=0&id=671de086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671de086",
  null
  
)

export default component.exports